const MainSearch = class extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.main-search__close').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.body.classList.remove('show-search');
      });
    });

    const searchInput = this.querySelector('.main-search__input');
    const clearButton = this.querySelector('.giant-search-clear');

    const syncClearButton = () => {
      if (clearButton) clearButton.hidden = searchInput.value.length === 0;
    };

    searchInput.addEventListener('keyup', (evt) => {
      if (evt.key === 'Escape') {
        this.querySelector('.main-search__close')?.dispatchEvent(new Event('click'));
      }
    });

    if (clearButton) {
      clearButton.addEventListener('click', (evt) => {
        evt.preventDefault();
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        syncClearButton();
        searchInput.focus();
      });
    }

    searchInput.addEventListener('input', syncClearButton);
    syncClearButton();

    if (this.dataset.quickSearch === 'true') {
      this.initQuickSearch();
    }
  }

  initQuickSearch() {
    const searchInput = this.querySelector('.main-search__input');
    const resultsBox = this.querySelector('.main-search__results');
    const searchTimeoutThrottle = 140;
    let searchTimeoutID = -1;
    let searchAbortController = null;
    let latestSearchToken = 0;

    const clearResults = () => {
      this.classList.remove('main-search--has-results', 'main-search--no-results', 'main-search--loading');
      resultsBox.innerHTML = '';
    };

    const handleInputChange = () => {
      const valueToSearch = searchInput.value.trim();
      const token = ++latestSearchToken;

      if (!valueToSearch.length) {
        this.oldSearchValue = '';
        if (searchAbortController) searchAbortController.abort();
        searchAbortController = null;
        clearTimeout(searchTimeoutID);
        clearResults();
        return;
      }

      if (valueToSearch === this.oldSearchValue) return;
      this.oldSearchValue = valueToSearch;

      if (searchAbortController) searchAbortController.abort();
      clearTimeout(searchTimeoutID);

      this.classList.remove('main-search--has-results', 'main-search--no-results');
      this.classList.add('main-search--loading');
      resultsBox.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';

      searchTimeoutID = setTimeout(() => {
        searchAbortController = new AbortController();
        const ajaxUrl = new URL(theme.routes.base + theme.routes.predictiveSearch, window.location.origin);
        ajaxUrl.searchParams.set('q', valueToSearch);
        ajaxUrl.searchParams.set('section_id', 'predictive-search');
        // La solicitud predictiva coincide con GiantV24: Shopify aplica sus
        // defaults de tipos, stock y alcance de resultados.
        ajaxUrl.searchParams.set('resources[limit]', '8');
        const includeMeta = this.dataset.quickSearchMeta === 'true';
        ajaxUrl.searchParams.set('resources[options][fields]', includeMeta
          ? 'title,product_type,variants.title,vendor,tag,variants.sku'
          : 'title,product_type,variants.title,vendor');

        fetch(ajaxUrl, { method: 'get', signal: searchAbortController.signal })
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            return response.text();
          })
          .then((response) => {
            if (token !== latestSearchToken) return;
            const template = document.createElement('template');
            template.innerHTML = response;
            const panel = template.content.querySelector('.giant-predictive-search');

            searchAbortController = null;
            this.classList.remove('main-search--loading', 'main-search--has-results', 'main-search--no-results');
            resultsBox.innerHTML = '';

            if (panel) {
              resultsBox.appendChild(panel);
              this.classList.add('main-search--has-results');
            } else {
              this.classList.add('main-search--no-results');
            }
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            if (token !== latestSearchToken) return;
            clearResults();
            this.classList.add('main-search--no-results');
            resultsBox.innerHTML = '<div class="giant-predictive-search__empty" role="status">No pudimos cargar las sugerencias. Probá nuevamente o presioná Enter para buscar.</div>';
            console.error('Giant predictive search:', error);
          });
      }, searchTimeoutThrottle);
    };

    searchInput.addEventListener('input', handleInputChange);
    searchInput.addEventListener('change', handleInputChange);

    if (searchInput.value.trim().length) {
      requestAnimationFrame(handleInputChange);
    }
  }
};

if (!customElements.get('main-search')) {
  window.customElements.define('main-search', MainSearch);
}
